import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'out-service',
    templateUrl: './outservice.component.html',
    styleUrls: ['./outservice.component.css']
})
export class OutServiceComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
